import { render } from "./fc3dfu.vue?vue&type=template&id=35664534&scoped=true"
import script from "./fc3dfu.vue?vue&type=script&lang=js"
export * from "./fc3dfu.vue?vue&type=script&lang=js"

import "./fc3dfu.vue?vue&type=style&index=0&id=35664534&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35664534"]])

export default __exports__